import { get, post } from 'api/request'

export const API_CONVERSATION = "/conversation/service/conversation"
export const API_QUEUE = "/conversation/service/queue"

export const getConversationDetail = (key) => get(`${API_CONVERSATION}/${key}`)
export const getConversationList = (contact, group, size) => {
  let params = { contact, order: "-last_active", group, size }
  return get(`${API_CONVERSATION}`, { urlParams: params })
}

// Fetches conversations linked to an arbitrary object (e.g. a Lead) via the `links`
// field set on conversation creation (see leads/pages/LeadDetail/fieldMenus.js's
// buildLeadLink) — same target_objects={type}:{uid} convention apps/leads/api/activity.js's
// getLeadActivityList and service/api/issue.js's getIssueActivityList also filter with.
// extraTargetObjects: additional "type:uid" strings OR'd into target_objects — used by
// Issue Detail to also fold in a linked lead's conversations.
export const getConversationListByTargetObject = (targetObjectType, targetObjectUid, size, extraTargetObjects = [], offset) => {
  const params = {
    target_objects: [`${targetObjectType}:${targetObjectUid}`, ...extraTargetObjects].join(','),
    order: "-last_active",
    size,
    ...(offset ? { offset } : {}),
  }
  return get(`${API_CONVERSATION}`, { urlParams: params })
}
export const startConversation = (data) => post(`${API_CONVERSATION}/new_conversation`, data)

export const getQueueList = () => get(`${API_QUEUE}`)
export const getAvailabilities = () => get(`${API_QUEUE}/availabilities`)

export const getConversationMessages = (key, startFrom = 0, size = 20, includePastMessages = 0) => {
  return get(`${API_CONVERSATION}/${key}?message_size=${size}&message_start_from=${startFrom}&include_past_messages=${includePastMessages}`)
} 

export const getOutboundTemplate = (queue, channel, account_type = '') => get(`${API_CONVERSATION}/outbound_template/?queue=${queue}&channel=${channel}&account_type=${account_type}`)